<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>POP Types</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item active">POP Types</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12" v-if="isCreate">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Add New Type</h5>
                </div>
                <div class="card-body">
                  <!-- <form> -->
                  <div class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label" for="title">Name</label>
                      <input v-model="name" class="form-control" id="color" type="text" placeholder="Enter Name"
                        aria-describedby="inputGroupPrepend" required />
                    </div>

                    <div class="col-md-3">
                      <label class="form-label" for="status">IP</label>
                      <input v-model="ip" class="form-control" id="status" type="text" placeholder="Enter IP"
                        aria-describedby="inputGroupPrepend" required />
                    </div>

                    <div class="col-md-3">
                      <label class="form-label" for="status">Address</label>
                      <input v-model="address" class="form-control" id="status" type="text" placeholder="Enter Address"
                        aria-describedby="inputGroupPrepend" required />
                    </div>
                  </div>
                  <button class="btn btn-primary" type="submit" @click="addNew">
                    Add
                  </button>
                  <!-- </form> -->
                </div>
              </div>
            </div>
            <!-- Update -->
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12" v-if="!isCreate">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Update Type</h5>
                </div>
                <div class="card-body">
                  <!-- <form> -->
                  <div class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label" for="title">Name</label>
                      <input v-model="update.name" class="form-control" id="color" type="text" placeholder="Enter Name"
                        aria-describedby="inputGroupPrepend" required />
                    </div>

                    <div class="col-md-3">
                      <label class="form-label" for="status">IP</label>
                      <input v-model="update.ip" class="form-control" id="status" type="text" placeholder="Enter IP"
                        aria-describedby="inputGroupPrepend" required />
                    </div>

                    <div class="col-md-3">
                      <label class="form-label" for="status">Address</label>
                      <input v-model="update.address" class="form-control" id="status" type="text"
                        placeholder="Enter Address" aria-describedby="inputGroupPrepend" required />
                    </div>
                  </div>
                  <button class="btn btn-primary" type="submit" @click="updateTypeSubmit">
                    Update
                  </button>
                  <button class="btn btn-danger" type="submit" @click="cancelUpdate">
                    Cancel
                  </button>
                  <!-- </form> -->
                </div>
              </div>
            </div>
            <!-- Data table -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                  <span>POP Types</span>
                </div>
                <div class="card-body">
                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="popListTBL">
                      <thead>
                        <tr align="center">
                          <th>#</th>
                          <th>Name</th>
                          <th>IP</th>
                          <th>Address</th>
                          <th>Active Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr align="center" v-for="(item, index) in popList" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.ip }}</td>
                          <td>{{ item.address }}</td>
                          <td>
                            <div class="media-body switch-sm" v-if="item.status === 1"
                              @click.prevent="changeStatus(item.id)">
                              <label class="switch">
                                <input type="checkbox" checked /><span class="switch-state"></span>
                              </label>
                            </div>
                            <div class="media-body switch-sm" v-if="item.status === 2"
                              @click.prevent="changeStatus(item.id)">
                              <label class="switch">
                                <input type="checkbox" /><span class="switch-state"></span>
                              </label>
                            </div>
                          </td>
                          <td>
                            <button class="btn btn-danger btn-xs" type="button"
                              data-original-title="btn btn-danger btn-xs" title="" @click.prevent="deleteType(item.id)">
                              Delete
                            </button>
                            <button class="btn btn-primary btn-xs" type="button"
                              data-original-title="btn btn-danger btn-xs" title="" @click.prevent="updateType(item)">
                              Edit
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import $ from "jquery";
import pop_typeAPI from "../../services/pop_type.API";

export default {
  name: "popList",
  components: {},
  data() {
    return {
      name: "",
      ip: "",
      popList: [],
      districtList: [],
      isCreate: true,
      update: {
        id: "",
        name: "",
        ip: "",
        address: ''
      },
      selectedDistrict: null,
      address: ''
    };
  },
  methods: {
    // district list
    getList() {
      pop_typeAPI.getList().then(
        (response) => {
          this.popList = response.data.data;
          console.log(response.data.data);
        },
        (err) => {
          if (err.response.data.success === false) {
            this.popList = [];
          }
        }
      );
    },

    // addNew
    addNew() {
      //   console.log(this.title, this.status);
      if (this.name == "") {
        this.$moshaToast("Please enter Name", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
      //  else if (this.ip == "") {
      //   this.$moshaToast("Please enter IP", {
      //     type: "danger",
      //     position: "top-right",
      //     showIcon: true,
      //   });
      // }
      else {
        let data = {
          name: this.name,
          ip: this.ip,
          address: this.address,
        };
        pop_typeAPI
          .createPopType(data)
          .then((response) => {
            this.$moshaToast(response.data.message, {
              type: "success",
              position: "top-right",
              showIcon: true,
            });
            // get all connection type
            pop_typeAPI.getList().then((response) => {
              this.popList = response.data.data;
            });
            this.name = "";
            this.ip = "";
            this.address = "";
          })
          .catch((error) => {
            // console.log(error.response.data.success);
            if (error.response.data.success === false) {
              this.$moshaToast(error.response.data.message, {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
            }
          });
      }
    },

    // delete
    deleteType(id) {
      if (id) {

        this.$swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {
            pop_typeAPI.deletePopType(id).then((response) => {
              this.$moshaToast(response.data.message, {
                type: "success",
                position: "top-right",
                showIcon: true,
              });
              // get all connection type
              pop_typeAPI.getList().then((response) => {
                this.popList = response.data.data;
              });
            });
          }
        });


      } else {
        this.$moshaToast("Please select service type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },

    // change status
    changeStatus(id) {
      if (id) {
        pop_typeAPI.changeStatus(id).then((response) => {
          this.$moshaToast(response.data.message, {
            type: "success",
            position: "top-right",
            showIcon: true,
          });
          // get all connection type
          pop_typeAPI.getList().then((response) => {
            this.popList = response.data.data;
          });
        });
      } else {
        this.$moshaToast("Please select connection type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },

    // update
    updateType(item) {
      this.isCreate = false;
      //   this.title = item.title;
      //   this.status = item.status === 1 ? true : false;
      this.id = item.id;
      // console.log(this.update);
      this.update.id = item.id;
      this.update.name = item.name;
      this.update.ip = item.ip;
      this.update.address = item.address;
    },

    // cancelUpdate
    cancelUpdate() {
      this.isCreate = true;
      this.update.id = "";
      this.update.name = "";
      this.update.ip = "";
      this.update.address = "";
      this.selectedDistrict = "";
    },

    // update submit
    updateTypeSubmit() {
      if (this.update.name == "") {
        this.$moshaToast("Please enter name", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      } else if (this.update.price == "") {
        this.$moshaToast("Please enter ip", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      } else {
        // console.log(this.update);
        let data = {
          id: this.update.id,
          name: this.update.name,
          ip: this.update.ip,
          address: this.update.address,
        };
        pop_typeAPI
          .updatePopType(data)
          .then((response) => {
            this.$moshaToast(response.data.message, {
              type: "success",
              position: "top-right",
              showIcon: true,
            });
            // get all connection type
            pop_typeAPI.getList().then((response) => {
              this.popList = response.data.data;
            });
            this.isCreate = true;
            this.update.id = "";
            this.update.name = "";
            this.update.ip = "";
            this.update.address = "";
            this.selectedDistrict = "";
          })
          .catch((error) => {
            // console.log(error.response.data.success);
            if (error.response.data.success === false) {
              this.$moshaToast(error.response.data.message, {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
            }
          });
      }
    },
  },
  mounted() {
    //   list
    pop_typeAPI.getList().then((response) => {
      this.popList = response.data.data;
      setTimeout(() => {
        $("#popListTBL").DataTable({
          lengthMenu: [
            [10, 25, 50, -1],
            [10, 25, 50, "All"],
          ],
          pageLength: 10,
          info: false,
          targets: "no-sort",
          bSort: false,
          order: [],
          bFilter: true,
          bInfo: false,
          //   bLengthChange: false,
          bDestroy: true,
        });
      });
    });
  },
};
</script>

<style scoped>
.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}
</style>
